import { render, staticRenderFns } from "./innovation.vue?vue&type=template&id=70d5d930&"
import script from "./innovation.vue?vue&type=script&lang=js&"
export * from "./innovation.vue?vue&type=script&lang=js&"
import style0 from "./innovation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports